var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccess = function SvgSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#69D4A1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 40,
    cy: 40,
    r: 36,
    fill: "#69D4A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3786 31.813L50.0815 28.5065C50.0266 28.4515 49.9615 28.4079 49.8898 28.3781C49.818 28.3483 49.7411 28.333 49.6635 28.333C49.5858 28.333 49.5089 28.3483 49.4371 28.3781C49.3654 28.4079 49.3003 28.4515 49.2454 28.5065L35.32 42.4413C35.2652 42.4963 35.2 42.5399 35.1283 42.5697C35.0566 42.5994 34.9797 42.6148 34.902 42.6148C34.8243 42.6148 34.7474 42.5994 34.6757 42.5697C34.604 42.5399 34.5388 42.4963 34.4839 42.4413L31.1868 39.1347C31.132 39.0797 31.0668 39.0361 30.9951 39.0063C30.9233 38.9766 30.8464 38.9613 30.7688 38.9613C30.6911 38.9613 30.6142 38.9766 30.5425 39.0063C30.4707 39.0361 30.4056 39.0797 30.3507 39.1347L27.0536 42.4413C26.9429 42.552 26.8807 42.7022 26.8807 42.8587C26.8807 43.0153 26.9429 43.1655 27.0536 43.2762L34.4839 50.7077C34.5388 50.7627 34.604 50.8063 34.6757 50.8361C34.7474 50.8659 34.8243 50.8812 34.902 50.8812C34.9797 50.8812 35.0566 50.8659 35.1283 50.8361C35.2 50.8063 35.2652 50.7627 35.32 50.7077L53.3786 32.6397C53.4868 32.5293 53.5474 32.3809 53.5474 32.2264C53.5474 32.0718 53.4868 31.9234 53.3786 31.813Z",
    fill: "#69D4A1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "success.1f357fa9b4ab2f39a96479d28305adc3.svg";